module.exports = __webpack_public_path__ + "static/media/FROM_11PM_TO_6AM.0dd6ad12.svg";